module.exports = __webpack_public_path__ + "img/chrome-step-4.5f8f2cfb.png";